import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetPromotionalOffersList } from "../../../utilities/api/promotionalOffer";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}
type PromotionalOfferListType = {
  createdAt: string
  name: string
  startTime: string
  endTime: string
  startDate: string
  endDate: string
  discountPercent: number
  id: string
  status: string
  sportName: []
}

const initialState = {
  AllPromotionalOfferData: [] as PromotionalOfferListType[],
  errorMessage: {} as ErrorMessageType,
}

export const AllPromotionalOfferList = createAsyncThunk(
  "PromotionalOfferList/AllPromotionalOfferList",
  () => GetPromotionalOffersList()
);

const PromotionalOfferListSlice = createSlice({
  name: "PromotionalOffer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(
        AllPromotionalOfferList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            state.AllPromotionalOfferData = action.payload.data.rows.map(
              (item: any, index: number) => ({
                srNo: index + 1,
                name: item.name,
                createdAt: item.createdAt,
                id: item.id,
                startTime: item.startTime,
                endTime: item.endTime,
                startDate: item.startDate,
                endDate: item.endDate,
                discountPercent: item.discountPercent,
                status: item.isActive ? "Active" : "Inactive",
                sportName: item.offerSports?.reduce((acc: any, cur: any) => acc + `${cur.sport?.name}, `, "")
              })
            );
          }
        }
      )
      .addCase(AllPromotionalOfferList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default PromotionalOfferListSlice.reducer;
